import axios from '@util/axios'

export const LincolnRLSGroupsService = {
  list: (RLS, include_id = true, options = {}) =>
    axios({
      ...options,
      url: '/lincoln/api/get/rls-groups/list/',
      params: {
        RLS,
        include_id
      }
    }),
  listUnderwriters: (underwriters = [], options = {}) =>
    axios({
      ...options,
      url: '/get/company-ids-by-uw-values/',
      method: 'POST',
      data: {
        underwriter_values: underwriters,
        exact_search: false
      }
    }),
  listRLSGroupsByRole: (role, role_value, options = {}) =>
    axios({
      ...options,
      url: '/lincoln/api/get/role-value-rls/',
      method: 'POST',
      data: {
        role,
        role_value
      }
    }),
  download: (
    company_name,
    tpa_id_list = [],
    underwriter_id_list = [],
    coverholder_id_list = [],
    broker_id_list = [],
    options = {}
  ) =>
    axios({
      ...options,
      url: '/lincoln/api/rls-groups/download/',
      method: 'POST',
      responseType: 'blob',
      data: {
        company_name,
        tpa_id_list,
        underwriter_id_list,
        coverholder_id_list,
        broker_id_list
      }
    }),
  upload: (company_id, formData, options = {}) =>
    axios({
      ...options,
      url: `/company/${company_id}/rls-group/upload/`,
      method: 'POST',
      data: formData
    })
}
